import { render, staticRenderFns } from "./ManufacturerAdd.vue?vue&type=template&id=5fe077d8&scoped=true&"
import script from "./ManufacturerAdd.vue?vue&type=script&lang=js&"
export * from "./ManufacturerAdd.vue?vue&type=script&lang=js&"
import style0 from "./ManufacturerAdd.vue?vue&type=style&index=0&id=5fe077d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe077d8",
  null
  
)

export default component.exports